import React, { Component } from 'react';
import {
  SectionsContainer,
  Section,
  Header
} from 'react-fullpage';
// import Parallax from 'react-springy-parallax';
// import logo from './logo.svg';
import HeaderBlock from './Header';
import HomeBlock from './blocks/HomeBlock';
import VideoBlock from './blocks/VideoBlock';
import LibBlock from './blocks/LibBlock';

import './App.css';

class App extends Component {
  constructor() {
    super();
    this.state = {
      nowSection: 0
    };
  }
  render() {
    const options = {
      sectionClassName:  'slide',
      anchors:           ['sectionOne', 'sectionTwo', 'sectionThree'],
      navigation:        false,
      sectionPaddingTop: '48px',
      arrowNavigation:   true,
      responsiveHeight:  900,
      scrollCallback: ({ activeSection }) => {
        this.setState({
          nowSection: activeSection
        });
      }
    };
    const { nowSection } = this.state;
    return (
      <div className="app">
        <Header><HeaderBlock /></Header>
        <SectionsContainer {...options} activeSection={nowSection}>
          <Section><HomeBlock isShow={nowSection === 0} /></Section>
          <Section><VideoBlock isShow={nowSection === 1} /></Section>
          <Section><LibBlock isShow={nowSection === 2} /></Section>
        </SectionsContainer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js